module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lPF8g"))).then(() => parcelRequire('8rm4T'));